import React, { useEffect, useState } from "react";
import { FaChevronCircleLeft } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router";
import { FormCabinetContext, cabinetInterface } from "./types";
import { Timeout, formattedDate } from "../../functions/functions";
import ButtonElement from "../../HtmlComponents/ButtonElement";
import InputsCabinet from "./forms/InputsCabinet";
import { useDispatch } from "react-redux";
import { EditCabinetApi } from "../../redux/cabinets/cabinetApiCalls";
import ShowErrorMsg from "../../HtmlComponents/ShowErrorMsg";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { DefaultDoctorInterface, DoctorInterface } from "../doctors/types";
import SuccessMsg from "../../Messages/SuccessMsg";

const UpdateCabinet = () => {
  const location = useLocation();
  const cabinet: cabinetInterface = location.state?.cabinet;

  const [name, setName] = useState(cabinet?.name);
  const [phone, setPhone] = useState(cabinet?.phone);
  const [address, setAddress] = useState(cabinet?.address);
  const [logo, setLogo] = useState<File | any>(cabinet?.logo);
  const [authorization, setAuthorization] = useState(cabinet?.authorization);
  const [type, setType] = useState(cabinet?.type);
  const [moughataa, setMoughataa] = useState<any>({
    value: cabinet.moughataa?._id,
    label: cabinet.moughataa?.name,
  });

  const [chooseDoctor, setChooseDoctor] = useState<any>(null);
  const [existedDoctor, setExistedDoctor] = useState<boolean>(true);

  const { doctors } = useSelector((state: State) => state.doctors);

  const [fullName, setFullName] = useState("");
  const [yearOfBirth, setYearOfBirth] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [sex, setSex] = useState("");
  const [telephone, setTelephone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [email, setEmail] = useState("");
  const [current, setCurrent] = useState<string>("");
  const [medecinType, setMedecinType] = useState("");
  const [origin, setOrigin] = useState("");
  const [inscriptionDate, setInscriptionDate] = useState(
    formattedDate(new Date("").toString())
  );
  const [avatar, setAvatar] = useState<File | any>(null);
  const [password, setPassword] = useState("");
  const [speciality, setSpeciality] = useState("");

  // const [doctorId, setDoctorId] = useState("")

  useEffect(() => {
    setMoughataa({
      value: cabinet.moughataa?._id,
      label: cabinet.moughataa?.name,
    });

    const doctorData =
      doctors.find(
        (doctor: DoctorInterface) =>
          doctor.cabinet?._id === cabinet._id && doctor.isOwner
      ) ?? DefaultDoctorInterface;
    // this is temporary
    setExistedDoctor(!doctorData.RegNo && true);

    setFullName(doctorData.fullName);
    setYearOfBirth(doctorData.yearOfBirth);
    setPlaceOfBirth(doctorData.placeOfBirth);
    setSex(doctorData.sex);
    setTelephone(doctorData.contact?.phone);
    setWhatsapp(doctorData.contact?.whatsapp);
    setEmail(doctorData.contact?.email);
    setCurrent(doctorData.nationality?.current);
    setOrigin(doctorData.nationality?.origin);
    setMedecinType(doctorData.medecinType?._id);
    // setMedecinType({ _id: doctorData.medecinType?._id, name: doctorData.medecinType?.title,   })
    setInscriptionDate(
      formattedDate(new Date(doctorData.inscriptionDate).toString())
    );
    setAvatar(doctorData?.avatar);
    setChooseDoctor({ value: doctorData._id, label: doctorData.fullName });
    // setDoctorId(doctorData._id)
    setSpeciality(doctorData.speciality);
  }, [doctors, cabinet]);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  const dispatch: any = useDispatch();

  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      formData.append("name", name);
      formData.append("phone", phone);
      formData.append("address", address);
      formData.append("logo", logo);
      formData.append("authorization", authorization);
      formData.append("type", type);
      formData.append("moughataa", moughataa?.value);
      formData.append("existedDoctor", JSON.stringify(existedDoctor));

      formData.append("doctor", chooseDoctor.value);
      formData.append("fullName", fullName);
      formData.append("yearOfBirth", yearOfBirth);
      formData.append("placeOfBirth", placeOfBirth);
      formData.append("sex", sex);
      formData.append(
        "contact",
        JSON.stringify({
          phone: telephone,
          whatsapp,
          email,
        })
      );

      formData.append(
        "nationality",
        JSON.stringify({
          current,
          origin,
        })
      );
      formData.append("medecinType", medecinType);
      formData.append("inscriptionDate", inscriptionDate);
      formData.append("avatar", avatar);
      formData.append("password", password);
      formData.append("speciality", speciality);

      const response: any = await dispatch(
        EditCabinetApi(cabinet._id, formData)
      );
      if (response === true) {
        // show success Msg
        setShowSuccessMsg(true);
        setTimeout(() => navigate("/cabinet"), Timeout);
      } else {
        setErrors(response);
      }

      setLoading(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormCabinetContext.Provider
      value={{
        name,
        setName,
        phone,
        setPhone,
        address,
        setAddress,
        logo,
        setLogo,
        authorization,
        setAuthorization,
        type,
        setType,
        moughataa,
        setMoughataa,
        chooseDoctor,
        setChooseDoctor,
        existedDoctor,
        setExistedDoctor,

        fullName,
        setFullName,
        yearOfBirth,
        setYearOfBirth,
        placeOfBirth,
        setPlaceOfBirth,
        sex,
        setSex,
        telephone,
        setTelephone,
        whatsapp,
        setWhatsapp,
        email,
        setEmail,
        current,
        setCurrent,
        medecinType,
        setMedecinType,
        origin,
        setOrigin,
        inscriptionDate,
        setInscriptionDate,
        avatar,
        setAvatar,
        password,
        setPassword,
        speciality,
        setSpeciality,
      }}
    >
      <div className="mt-20 p-4 bg-white rounded-xl shadow-md">
        <SuccessMsg
          modal={showSuccessMsg}
          toggle={() => setShowSuccessMsg(!showSuccessMsg)}
        />

        {/* Title */}
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-bold text-gray-800">
            Modifier les informations du clinique
          </h1>
          <button
            onClick={() => navigate(-1)}
            title="Retour"
            className="p-2 rounded-full btn-main"
          >
            <FaChevronCircleLeft className="text-xl" />
          </button>
        </div>

        {/* Error message if any */}
        <ShowErrorMsg errors={errors} setErrors={setErrors} />

        {/* Form */}
        <form
          className="grid md:grid-cols-2 gap-4"
          encType="multipart/form-data"
          onSubmit={handleSubmit}
        >
          {/* Left + Right side form inputs */}
          <InputsCabinet />

          {/* Submit button */}
          <div className="justify-self-end mt-4">
            <ButtonElement type="submit" loading={loading} typeBtn="Modifier" />
          </div>
        </form>
      </div>
    </FormCabinetContext.Provider>
  );
};

export default UpdateCabinet;
